import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type AdventureSummary } from '../lib/api.js';
import { AppHeader } from '../components/AppHeader.js';
import '../styles/adventures.css';

export function AdventuresIndex(): JSX.Element {
  const [list, setList] = useState<AdventureSummary[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.adventures().then((r) => setList(r.adventures)).catch((e: Error) => setErr(e.message));
  }, []);

  return (
    <div className="wiki-shell" style={{ gridTemplateColumns: '1fr' }}>
      <AppHeader />
      <main className="adv-index" style={{ gridColumn: '1 / -1' }}>
        <h1>Збірка пригод</h1>
        <p className="lede">Кампанії та пригоди світу Хронік Альбіону.</p>

        {err && <div className="wiki-error">⚠ {err}</div>}
        {!list && !err && <div className="wiki-loading">завантаження…</div>}

        <div className="adv-grid">
          {list?.map((adv) => {
            const tier = adv.meta.tier ?? 1;
            return (
              <Link key={adv.slug} to={`/adventures/${encodeURIComponent(adv.slug)}`} className="adv-card">
                <div className="order">№ {adv.order}</div>
                <h3>{adv.meta.name ?? adv.slug}</h3>
                {adv.meta.subtitle && <div className="sub">{adv.meta.subtitle}</div>}
                <div className="meta-row">
                  {adv.meta.tier !== undefined && <span className={`chip tier-${tier}`}>Tier {tier}</span>}
                  {adv.meta.levels && <span className="chip">рівні {adv.meta.levels}</span>}
                  {adv.meta.duration && <span className="chip">{adv.meta.duration}</span>}
                  {adv.meta.location && <span className="chip">{adv.meta.location}</span>}
                </div>
              </Link>
            );
          })}
        </div>
      </main>
    </div>
  );
}
